import React, { useState } from 'react';
import {
  Autocomplete,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField as MuiTextField,
} from '@mui/material';
import { Button } from '@finpay-development/shared-components';
import {
  FacilityWithNpi,
  facilityDisplayName,
} from '../utils/availity-vob';

export interface SelectFacilityForAvailityDialogProps {
  open: boolean;
  facilities: FacilityWithNpi[];
  isRunning?: boolean;
  onCancel: () => void;
  onConfirm: (facility: FacilityWithNpi) => void;
}

export const SelectFacilityForAvailityDialog: React.FC<
  SelectFacilityForAvailityDialogProps
> = ({ open, facilities, isRunning = false, onCancel, onConfirm }) => {
  const [selected, setSelected] = useState<FacilityWithNpi | null>(null);

  return (
    <Dialog
      open={open}
      onClose={isRunning ? undefined : onCancel}
      maxWidth="xs"
      fullWidth
      test-id="select-facility-for-availity-dialog"
      TransitionProps={{
        onExited: () => setSelected(null),
      }}
    >
      <DialogTitle sx={{ textAlign: 'center' }}>
        Select Facility for Availity VOB
      </DialogTitle>
      <DialogContent>
        <Autocomplete
          options={facilities}
          value={selected}
          onChange={(_, value) => setSelected(value)}
          getOptionLabel={(option) => facilityDisplayName(option)}
          isOptionEqualToValue={(a, b) =>
            Number(a.facilityId) === Number(b.facilityId)
          }
          renderOption={(props, option) => (
            <li {...props} key={option.facilityId}>
              {facilityDisplayName(option)}
              {option.npi ? ` (NPI ${option.npi})` : ''}
            </li>
          )}
          renderInput={(params) => (
            <MuiTextField
              {...params}
              label="Facility"
              placeholder="Search facilities"
              margin="dense"
              fullWidth
            />
          )}
          test-id="select-facility-for-availity-autocomplete"
        />
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center', gap: 1, pb: 2 }}>
        <Button
          onClick={onCancel}
          disabled={isRunning}
          test-id="select-facility-for-availity-cancel"
        >
          Cancel
        </Button>
        <Button
          onClick={() => {
            if (selected) {
              onConfirm(selected);
            }
          }}
          disabled={isRunning || !selected}
          test-id="select-facility-for-availity-run"
        >
          {isRunning ? 'Running...' : 'Run Availity'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
